import { render } from "./Modal.vue?vue&type=template&id=5e837b0a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=5e837b0a&scoped=true&lang=css"

import exportComponent from "/home/oliver/Development/auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e837b0a"]])

export default __exports__